<template>
  <div class="StartView">
    <PageHeader title="Strona startowa"
                class="StartView__header"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <StartedPageCardsLayout />
    </ShPageLayout>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        Jak zainstalować aplikację call web?
      </template>
      <template #description>
        <PopupHints hint-template-name="start" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import StartedPageCardsLayout from '@/components/StartedPage/StartedPageCardsLayout';

export default {
  name: 'Start',
  components: {
    PageHeader,
    PopupHints,
    ShPageLayout,
    ShModalWindow,
    StartedPageCardsLayout,
  },

  mixins: [PopupHintsUtils],

  async created() {
    this.hintModalVisible = false;
  },
};
</script>
